export default __webpack_public_path__ + "img/dd4e3e25e86ed00f456ea4c0021bb920.svg";